import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ProfileDropdown from "./profile";
import "./Header.css";

/**
 * Page header. The title comes from the same backend-driven menu the sidebar
 * uses, so adding a route needs no change here.
 */

const splitTitle = (label) => {
  const words = String(label).trim().split(/\s+/);
  if (words.length === 1) return [words[0], ""];
  return [words[0], words.slice(1).join(" ")];
};

export default function Header() {
  const location = useLocation();
  const { menu } = useAuth();

  const [scriptTitle, sansTitle] = useMemo(() => {
    const path = location.pathname.toLowerCase();
    const match =
      menu.find((item) => item.route?.toLowerCase() === path) ||
      menu.find((item) => item.route && path.startsWith(`${item.route.toLowerCase()}/`));
    if (match) return splitTitle(match.label);

    // Fall back to the last path segment so a route missing from the menu
    // still shows something meaningful.
    const segment = location.pathname.split("/").filter(Boolean).pop() || "Portal";
    return splitTitle(segment.replace(/-/g, " "));
  }, [menu, location.pathname]);

  return (
    <header className="header">
      <div className="left-section">
        <span
          className="page-header-mark"
          aria-label={`${scriptTitle} ${sansTitle}`.trim()}
        >
          <span className="page-header-script">{scriptTitle}</span>
          {sansTitle && <span className="page-header-sans">{sansTitle}</span>}
        </span>
      </div>

      <div className="right-section">
        <ProfileDropdown />
      </div>
    </header>
  );
}
